import { render, staticRenderFns } from "./PosStats.vue?vue&type=template&id=5afb468b&scoped=true&"
import script from "./PosStats.vue?vue&type=script&lang=js&"
export * from "./PosStats.vue?vue&type=script&lang=js&"
import style0 from "./PosStats.vue?vue&type=style&index=0&id=5afb468b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afb468b",
  null
  
)

export default component.exports